import React, { Suspense } from "react";

import {
  BlockingErrorBoundary,
  ErrorNamespaceProvider,
  useErrorNamespace,
} from "../error_handling";
import { Page } from "./Page";

const PageErrorBoundary = ({ children, page }) => {
  const namespace = useErrorNamespace();

  return (
    <ErrorNamespaceProvider
      namespace={`shell_funnel_${namespace}_page_${page}`}
    >
      <BlockingErrorBoundary name={`funnel_${namespace}_page_${page}`}>
        {children}
      </BlockingErrorBoundary>
    </ErrorNamespaceProvider>
  );
};

export const createPage = (
  page,
  Component,
  { fallback = null, delay } = {},
) => {
  return () => (
    <PageErrorBoundary page={page}>
      <Page path={page} delay={delay}>
        <Suspense fallback={fallback}>
          <Component />
        </Suspense>
      </Page>
    </PageErrorBoundary>
  );
};
